import { call, takeEvery, put, select } from 'redux-saga/effects'
import { ADMIN_WELCOME_EMAIL } from '../actionTypes'
import makeAPIRequest from 'store/entities/api/sagas'
import { ADMIN_WELCOME_EMAIL_PATH, SUPER_ADMIN_WELCOME_EMAIL_PATH } from 'app/constants/api/adminWelcomeEmail'
import * as ROLES from 'app/constants/roles'
import { getIdentityActiveRoleName } from 'store/entities/identity/selectors'
import { getOrganizationUsersOrganizationId } from 'store/entities/organizations/selectors'
import { adminWelcomeEmail } from '../actions'
import { GET } from 'app/constants/requests'
import { showError } from 'store/entities/toastr/utils'

export default function* saveAdminWelcomeEmailSaga() {
  yield takeEvery(ADMIN_WELCOME_EMAIL.GET.REQUEST, handleSaveWelcomeEmailRequest)
}

export function* handleSaveWelcomeEmailRequest() {
  try {
    const roleName = yield select(getIdentityActiveRoleName)
    const orgId = yield select(getOrganizationUsersOrganizationId)
    const path = roleName === ROLES.ADMIN ? ADMIN_WELCOME_EMAIL_PATH : SUPER_ADMIN_WELCOME_EMAIL_PATH(orgId)
    const response = yield call(makeAPIRequest, path, {
      method: GET,
    })
    yield put(adminWelcomeEmail.get.success(response.data.data))
  } catch (badResponse) {
    showError()
    yield put(adminWelcomeEmail.get.fail())
  }
}
